<template>
  <LLConfirmModal class="StudyNewPageUnfinishedContent">
    <template #title>
      {{ $t('conversation-leave-warning_title_normal') }}
    </template>
    <template #default>
      <div class="StudyNewPageUnfinishedContent__content">
        <div class="StudyNewPageUnfinishedContent__top-description">
          {{ $t('conversation-leave-warning_top-description') }}
        </div>
        <div
          v-for="question in localUnsavedQuestions"
          :key="question.id"
          class="StudyNewPageUnfinishedContent__question"
        >
          <div v-if="messageState(question.id)" class="StudyNewPageUnfinishedContent__question-icon">
            <LoadingIcon
              v-if="messageState(question.id) === MessageSendingStates.SENDING"
              class="StudyNewPageUnfinishedContent__question-icon-loading"
            ></LoadingIcon>
            <ClearIcon
              v-else-if="messageState(question.id) === MessageSendingStates.ERROR"
              class="StudyNewPageUnfinishedContent__question-icon-warning"
            ></ClearIcon>
            <SuccessIcon
              v-else-if="messageState(question.id) === MessageSendingStates.SUCCESS"
              class="StudyNewPageUnfinishedContent__question-icon-success"
            ></SuccessIcon>
          </div>
          <div class="StudyNewPageUnfinishedContent__question-number">
            {{
              $t('conversation-leave-warning_question-number', { questionNumber: questionIndex(question.id) })
            }}
          </div>
          <div class="StudyNewPageUnfinishedContent__question-title">{{ question.title }}</div>
        </div>
        <div class="StudyNewPageUnfinishedContent__bottom-description">
          {{ $t('conversation-leave-warning_bottom-description') }}
        </div>
      </div>
    </template>
    <template #actions>
      <div class="StudyNewPageUnfinishedContent__actions">
        <LLButton
          class="StudyNewPageUnfinishedContent__action"
          green
          :disabled="isPending"
          small
          @click.native="submitClick"
        >
          {{ $t('conversation-leave-warning_action_submit') }}
        </LLButton>
        <LLButton
          class="StudyNewPageUnfinishedContent__action"
          :disabled="isPending"
          small
          secondary
          @click.native="notNowClick"
          >{{ $t('conversation-leave-warning_action_not-now') }}</LLButton
        >
        <LLButton
          class="StudyNewPageUnfinishedContent__action"
          :disabled="isPending"
          small
          @click.native="cancelClick"
          >{{ $t('conversation-leave-warning_action-cancel') }}</LLButton
        >
      </div>
    </template>
  </LLConfirmModal>
</template>

<script>
import LLButton from '@/components/common/ui-components/LLButton.vue'
import LoadingIcon from '@/components/common/LoadingIcon.vue'
import LLConfirmModal from '@/components/common/LLConfirmModal.vue'
import SuccessIcon from '@/assets/icons/SuccessIcon.vue'
import ClearIcon from '@/assets/icons/ClearIcon.vue'
import MessageSendingStates from './messageSendingStates.json'

export default {
  name: 'StudyNewPageUnfinishedContent',
  components: { SuccessIcon, ClearIcon, LoadingIcon, LLConfirmModal, LLButton },
  props: {
    sendingStates: { type: Object, default: () => {} },
    questions: { type: Array, required: true, default: () => [] },
    isPending: { type: Boolean, default: false },
    questionIndexes: { type: Object, default: () => {} }
  },
  data() {
    return {}
  },
  computed: {
    MessageSendingStates() {
      return MessageSendingStates
    },
    localUnsavedQuestions() {
      return this.questions
    }
  },
  methods: {
    questionIndex(questionId) {
      return this.questionIndexes[questionId] !== undefined ? this.questionIndexes[questionId] + 1 : 0
    },
    cancelClick() {
      this.$emit('cancel')
    },
    submitClick() {
      this.$emit('submit')
    },
    notNowClick() {
      this.$emit('skip')
    },
    messageState(questionId) {
      return this.sendingStates?.[questionId]
    }
  }
}
</script>

<style scoped lang="scss">
.StudyNewPageUnfinishedContent {
  &__top-description {
    @apply mb-5;
  }
  &__bottom-description {
    @apply mt-5;
  }
  &__content {
    max-width: 500px;
  }

  &__actions {
    @apply flex;
    @screen mob-only {
      @apply flex-col items-end;
    }
  }
  &__action {
    @apply ml-4;
    &:first-child {
      @apply ml-0;
    }
    @screen mob-only {
      @apply ml-0 mt-2;
      &:first-child {
        @apply mt-0;
      }
    }
  }
  &__question {
    @apply flex items-center min-w-0;
    &-icon {
      @apply w-5 h-5 mr-3 flex-shrink-0;
      &-loading {
        @apply w-5 h-5;
      }
      &-warning {
        @apply w-full h-full text-status-03-600;
      }
      &-success {
        @apply w-full h-full text-status-01-600;
      }
    }
    &-number {
      @apply mr-2 text-button-01;
    }
    &-title {
      @apply flex-1 truncate;
    }
  }
}
</style>
